
const teamData = {

	title: "Our Team",
	team: [
		{
			image: {
				src: "/assets/images/team/tracey.jpg",
				alt: "Tracey Henry",
			},
			name: "Tracey Henry",
			title: "CEO",
		},
		{
			image: {
				src: "/assets/images/team/riekie.jpg",
				alt: "Riekie van Tonder",
			},
			name: "Riekie van Tonder",
			title: "Finance, Compliance and Business Manager",
		},
		{
			image: {
				src: "/assets/images/team/Zandile_Ntuli.png",
				alt: "Zandile Ntuli",
			},
			name: "Zandile Ntuli",
			title: "Head of Programmes",
		},
		{
			image: {
				src: "/assets/images/team/Thandi-Lekeba.png",
				alt: "Thandi Lekeba ",
			},
			name: "Thandi Lekeba ",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/Mmakgosi_Chaane-Pule.png",
				alt: "Mmakgosi Chaane-Pule",
			},
			name: "Mmakgosi Chaane-Pule",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/bongekile.png",
				alt: "Noreen Moloi",
			},
			name: "Bongekile Ndlela",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/noreen.png",
				alt: "Noreen Moloi",
			},
			name: "Noreen Moloi",
			title: "Scholar Development Officer",
		},
		{
			image: {
				src: "/assets/images/team/Kgaogelo_Seemola.jpg",
				alt: "Kgaogelo Seemola ",
			},
			name: "Kgaogelo Seemola ",
			title: "Scholar Development Officer",
		},
		{
			image: {
				src: "/assets/images/team/Lethokuhle_Gamede.jpg",
				alt: "Lethokuhle Gamede",
			},
			name: "Lethokuhle Gamede",
			title: "PA to CEO and Team Assistant",
		},

	],

}

export { teamData };
